/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View } from 'react-native'
import styles from './Styles/TextComponentStyle'
import {Text} from 'native-base';
import { Fonts } from '../Themes'

export default class TextComponent extends Component {

  render () {
    const {adjustsFontSizeToFit = true, allowFontScaling = true} = this.props
    // if props.style is passed in as an array, have to split it before adding it to the style array
    let stylesArray = Array.isArray(this.props.style) ? [styles.text,...this.props.style, {fontFamily: Fonts.style.font.regular}] : [styles.text,this.props.style, {fontFamily: Fonts.style.font.regular}]
    //console.log("styles array = " + JSON.stringify(stylesArray))
    return (
        <View style = {this.props.containerStyle}>
        <Text
        allowFontScaling={allowFontScaling}
        adjustsFontSizeToFit={adjustsFontSizeToFit}
         numberOfLines = {this.props.numberOfLines} onPress = {this.props.onPress} style = {stylesArray}>{this.props.text}</Text>
        </View>
    )
  }
}
